export default __webpack_public_path__ + "static/start-rocket-8a3f6be7a601952c8466877a09cf50f6.png";